module.exports = __webpack_public_path__ + "static/media/logo_hypeschools.08630b4d.svg";